import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';
import { fontFamilies } from '../../constants/theme';
import { figmaLetterSpacing } from '../../ui/utils';

export const HeroContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  bgcolor: 'transparent',
  color: theme.palette.text.primary,
  maxWidth: '1070px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 50,
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
  },
}));

export const HeroTextWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 20,
});

// The eyebrow line above the headline is not a heading — the headline below it
// is the page's <h1>. Tailwind's preflight zeroes margins, so the tag swap is
// visually identical.
export const HeroOverHeading = styled('p')(({ theme }) => ({
  ...theme.typography.overHeading,
  fontSize: '28px',
  fontWeight: 500,
  letterSpacing: figmaLetterSpacing(28, -1),
  fontFamily: fontFamilies.gotham,
  [theme.breakpoints.down('md')]: {
    fontSize: '20px',
    fontWeight: 300,
    fontFamily: fontFamilies.gotham,
  },
}));

export const HeroHeading = styled(Typography)(({ theme }) => ({
  ...theme.typography.heading,
  fontSize: '60px',
  letterSpacing: figmaLetterSpacing(60, -1),
  fontFamily: fontFamilies.gotham,
  lineHeight: '74px',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: '25px',
    fontWeight: 300,
    lineHeight: '44px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '40px',
  },
}));

export const HeroSubtext = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  whiteSpace: 'pre-line',
  fontSize: '28px',
  lineHeight: '1.25',
  letterSpacing: figmaLetterSpacing(28, 3),
  maxWidth: 1035,
  [theme.breakpoints.down('md')]: {
    maxWidth: '360px',
    fontSize: '16px',
    fontWeight: 300,
    textWrap: 'wrap',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '20px',
  },
}));

export const HeroSubHeading = styled(HeroSubtext)({
  fontWeight: 600,
});

export const ExternalText = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  fontFamily: fontFamilies.quicksand,
  fontSize: 16,
  fontWeight: 500,
  lineHeight: '20px',
  letterSpacing: figmaLetterSpacing(16, 3),
  color: theme.palette.text.primary,
  textAlign: 'center',
  maxWidth: 900,
  whiteSpace: 'pre-line',
  textWrap: 'balance',
  margin: '0 auto',
}));
